import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TipoPagamento } from '../../../models/TipoPagamento';

interface PaymentProps {
  tipo: TipoPagamento | null;
  valor: number;
  usarYuno: boolean;
}

const INITIAL_STATE: PaymentProps = {
  valor: 0,
  tipo: null,
  usarYuno: false
};

export const paymentSlice = createSlice({
  name: 'payment',
  initialState: INITIAL_STATE,
  reducers: {
    setValor: (state, action: PayloadAction<number>) => {
      const valor = action.payload;
      state.valor = valor;
    },
    setTipo: (state, action: PayloadAction<TipoPagamento | null>) => {
      const tipo = action.payload;
      state.tipo = tipo;
    },
    setUsarYuno: (state, action: PayloadAction<boolean>) => {
      state.usarYuno = action.payload;
    }
  }
});

export const { setValor, setTipo, setUsarYuno } = paymentSlice.actions;

export default paymentSlice;
